/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterDateRangeMode = typeof WebFilterDateRangeMode[keyof typeof WebFilterDateRangeMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterDateRangeMode = {
  Overlap: 'Overlap',
  Departures: 'Departures',
} as const;
